import {Show} from 'platform/foundation';

import {CardOo} from '../../components/CardOo/CardOo';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {FinancialProductSummary} from './FinancialProductSummary';
import {ReservationPrices} from './ReservationPrices';
import {shouldRenderReservationCard} from './utils/shouldRenderReservationCard';

type ReservationCardType = {
  isExpired?: boolean;
};

export function ReservationCard(_props: ReservationCardType) {
  const offer = useGetOnlineOfferData();

  return (
    <>
      <Show when={shouldRenderReservationCard(offer)}>
        <CardOo backgroundColor="semantic.bg.subtle">
          <ReservationPrices />
        </CardOo>
      </Show>
      <FinancialProductSummary />
    </>
  );
}
